import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ArrayHelpers, DomHelpers, Help, Loading, Paging, SystemText } from 'e4shared';
import { Link, withRouter } from 'react-router-dom';
import { apiGet } from 'services';

import './latestQuestions.css';
import WidgetBase from 'views/myDashboard/components/widgets/_base';
import { e4Format, e4Formats } from 'helpers/dates';

export const LatestQuestions = ({ item, history }) => {
    const loaded = React.useRef(null);
    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState([]);
    const [pagedData, setPagedData] = React.useState([]);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(6);
    const recordCount = data.length;
    const rowHeight = 90;
    const extrasHeight = 60;

    const user = useSelector(state => state.user.user);

    const gotResponse = response => {
        response && setData(response);
        setLoading(false);
    };

    React.useEffect(() => {
        !loading && loaded.current && DomHelpers.truncateText('widget-qb-title', loaded.current, 55);
    }, [loading, loaded.current, item.w, page]);

    React.useEffect(() => {
        apiGet(`question-bank/latest`, user.guid, response => gotResponse(response));
    }, [user.guid]);

    React.useEffect(() => {
        setPagedData(ArrayHelpers.getPage(data, page, pageSize));
    }, [page]);

    React.useEffect(() => {
        const pageSizeGenerator = () => {
            const thisHeight = 110 * item.h - 50;
            let result = Math.ceil((thisHeight - extrasHeight) / rowHeight, 0);
            if (result < recordCount) result--;
            return result < 1 ? 1 : result;
        };

        const ps = pageSizeGenerator();
        setPagedData(ArrayHelpers.getPage(data, 1, ps));
        setPage(1);
        setPageSize(ps);
    }, [loaded.current, data, item.h, recordCount]);

    const text = {
        none: SystemText('Home/Widgets/Knowledge/None'),
        add: SystemText('Home/Widgets/Knowledge/Add'),
        featured: SystemText('Home/Widgets/Knowledge/Featured'),
        answered: SystemText('Home/Widgets/Knowledge/Answered'),
        asked: SystemText('Home/Widgets/Knowledge/Asked'),
        on: (d, t) => SystemText('Home/Widgets/Knowledge/On', d, t),
        answers: SystemText('Home/Widgets/Knowledge/Answers'),
        likes: SystemText('Home/Widgets/Knowledge/Likes'),
    };

    const chart = (
        <div id="latest-questions" ref={loaded}>
            {data.length === 0 ? (
                <div>
                    <p>{text.none}</p>
                    <Link to="/knowledge-bank">
                        <button className="mt20 btn btn-primary">{text.add}</button>
                    </Link>
                </div>
            ) : (
                <div>
                    {pagedData.map(question => {
                        return (
                            <div
                                key={`post-${question.id}`}
                                className="pt5 pb5"
                                style={{ height: `${rowHeight}px`, borderBottom: 'solid 1px #ebebeb' }}
                            >
                                <div className="flex">
                                    <div className="mr5 text-center">
                                        <i
                                            style={{ fontSize: '20px' }}
                                            className={`fa ${
                                                question.answer ? 'fa-check-circle' : 'fa-question-circle'
                                            } text-success`}
                                        />
                                    </div>
                                    <div className="flex-grow">
                                        <div className="flex text-lg mb5">
                                            <button
                                                onClick={() => history.push(`/knowledge-bank/${question.id}`)}
                                                className="btn-link"
                                                title={question.name}
                                            >
                                                <div className="ellipse widget-qb-title">{question.name}</div>
                                            </button>
                                            {question.sticky && (
                                                <div className="flex-grow text-right">
                                                    <i
                                                        title={text.featured}
                                                        className="fa fa-thumb-tack text-warning"
                                                        style={{ fontSize: '18px' }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="text-sm">
                                            {question.answer ? text.answered : text.asked}
                                            <button
                                                className="btn-link"
                                                onClick={() => history.push(`/search/${question.owner_Full_Name}`)}
                                            >
                                                {question.owner_Full_Name}
                                            </button>
                                            <div className="text-sm">
                                                {text.on(e4Format(question.created, e4Formats.longWithDay, true))}
                                            </div>
                                        </div>
                                        <div className="text-sm">
                                            <span className="mr10" title={text.answers}>
                                                <i className="fa fa-reply" /> {question.answerCount}
                                            </span>
                                            <span title={text.likes}>
                                                <i className="fa fa-thumbs-up" /> {question.likes}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    {recordCount > pageSize && (
                        <div className="text-center mt10">
                            <Paging
                                page={page}
                                narrow={item.w < 3}
                                pageSize={pageSize}
                                recordCount={recordCount}
                                goToPage={setPage}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );

    return (
        <WidgetBase
            filters={null}
            chart={chart}
            item={item}
            id={'latest-questions'}
            help={null}
            hideConfig
            extra={null}
            loading={loading}
        />
    );
};

export default withRouter(LatestQuestions);
